export default __webpack_public_path__ + "static/12-34f5fee5a42c63b44b1a48d6f805bc87.jpg";